import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";

import { AssetSymbol } from "../../../types/models/AssetSymbol";
import { getSymbolLogo } from "../../../utils/tradeUtils";

interface ListProps {
  onClick: (asset: AssetSymbol) => void;
  assets: AssetSymbol[];
}

const AssetList: React.FC<ListProps> = ({ onClick, assets }) => {
  const { t } = useTranslation();
  return (
    <div className="asset-list">
      <div className="asset-list_row">
        <p>{t("asset")}</p>
        <p>
          <span>{t("oneMinPlus")}</span>
          <span>{t("fiveMinPlus")}</span>
        </p>
      </div>
      {assets.map((asset: AssetSymbol) => {
        return (
          <div className="asset-list_row" onClick={() => onClick(asset)}>
            <div className="asset-list_row-name">
              <img
                src={getSymbolLogo(asset.symbol, asset.logo)}
                alt="symbol"
                style={{
                  borderRadius: asset?.logo ? "50%" : "0",
                }}
              />
              <Typography
                sx={{
                  color: "white !important",
                  textAlign: "center",
                  marginTop: "auto",
                  marginBottom: "auto",
                  paddingLeft: "10px",
                }}
                color="inherit"
              >
                {asset.name}
              </Typography>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AssetList;
